import { useNavigate } from '@tanstack/react-router';
import { useOpenDm } from '../data/channels';
import { reportError } from '../lib/error-report';

/**
 * Nevre vagy profilkepre kattintva DM nyilik az illetovel.
 *
 * A csatornaban ez a leggyakoribb kovetkezo lepes: latod, ki irt valamit, es
 * negyszemkozt kerdeznel rola. Eddig ehhez a gyorsvaltoban kellett ujra
 * kikeresni a nevet - pedig ott van a szemed elott.
 *
 * ─── Kire NEM kattinthatunk ─────────────────────────────────────────────────
 *
 *  - Sajat magunkra: a kerdes "beszelj a masikkal" volt. (A sajat jegyzetek
 *    az oldalsavbol elerhetok.)
 *  - Botra es webhookra: nekik nincs kihez beszelni.
 *  - Rendszeruzenetre, aminek nincs szerzoje.
 *
 * Ilyenkor sima szoveg marad, kattintasi jelzes nelkul - egy gomb, ami nem
 * csinal semmit, rosszabb, mint ha ott sem lenne.
 */
export function UserLink({
  userId,
  meId,
  disabled = false,
  label,
  onDone,
  className = '',
  children,
}: {
  userId: string | null | undefined;
  meId: string;
  /** Bot vagy webhook-nev: vele nincs ertelme beszelgetni. */
  disabled?: boolean;
  /** A megjeleno nev - a buboreksugohoz kell. */
  label: string;
  /** Parbeszedablakbol hivva: az ablakot be kell csukni az atlepes elott. */
  onDone?: () => void;
  className?: string;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const openDm = useOpenDm();

  const target = !disabled && userId && userId !== meId ? userId : null;
  if (!target) return <span className={className}>{children}</span>;

  return (
    <>
      <button
        type="button"
        title={
          openDm.isError
            ? 'Nem sikerült megnyitni a beszélgetést. Próbáld újra.'
            : `Üzenet neki: ${label}`
        }
        /* Ket kattintas ne nyisson ket kort ugyanarra a beszelgetesre. */
        disabled={openDm.isPending}
        onClick={() =>
          openDm.mutate([target], {
            onSuccess: (result) => {
              onDone?.();
              void navigate({ to: '/c/$channelId', params: { channelId: result.channel.id } });
            },
            // Nem nyeljuk el: a hibajelento lassa, a buboreksugo pedig elmondja.
            onError: (error) => reportError(error, 'dm-nyitas'),
          })
        }
        className={[
          'cursor-pointer transition-opacity duration-(--duration-quick) hover:opacity-80',
          'disabled:cursor-wait disabled:opacity-60',
          className,
        ].join(' ')}
      >
        {children}
      </button>
      {/*
        A nev egy sor KOZEPEN all - lathato hibaszoveg szetverne a sort. A
        buboreksugot viszont a felolvaso nem mondja el, ezert ez kulon szol.
      */}
      {openDm.isError && (
        <span role="alert" className="sr-only">
          Nem sikerült megnyitni a beszélgetést vele: {label}. Próbáld újra.
        </span>
      )}
    </>
  );
}
